module.exports = __webpack_public_path__ + "img/18_7.b399fa31.png";